<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'IkPopup',
  props: {
    popUpHeadline: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['showIkModal', 'fromUrl']),

    toggleModal() {
      if (this.showIkModal) {
        this.$nextTick(() => {
          $('#ikPopupModal').modal('show');
        });
        return true;
      }else {
        this.$nextTick(() => {
          $('#ikPopupModal').modal('hide');
        });
        return false;
      }
    },
  },
  methods: {
    ...mapActions(),
    localClicked(value) {
      if (value) {
        this.$store.commit('SET_FROM_URL', 'IK-Landing-' + value);
      }
      this.$nextTick(() => {
        $('#ikPopupModal').modal('hide');
      });
      this.$store.commit('SET_SHOW_IK_MODAL', false);
    },
  },
};
</script>

<template>
  <div v-if="toggleModal" class="form-popup-selection">
    <button id="selectionPopupTrigger" data-toggle="modal" data-target="#ikPopupModal"></button>
    <div class="modal fade" id="ikPopupModal" tabindex="-1" role="dialog" aria-labelledby="ikPopupModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ikPopupModal">{{ popUpHeadline }}</h5>
          </div>
          <div class="modal-body">
            <div>
              <button @click="localClicked('Berlin-Tempelhof')" class="sel-btn btn btn-primary">Berlin Tempelhof</button>
              <button @click="localClicked('Berlin-Waltersdorf')" class="sel-btn btn btn-primary">Berlin Waltersdorf</button>
              <button @click="localClicked('Berlin-Spandau')" class="sel-btn btn btn-primary">Berlin Spandau</button>
              <button @click="localClicked('Berlin-Lichtenberg')" class="sel-btn btn btn-primary">Berlin Lichtenberg</button>
              <button @click="localClicked('Studio-Berlin-Steglitz')" class="sel-btn btn btn-primary">Studio Berlin Steglitz</button>
              <button @click="localClicked('Studio-Berlin-Pankow')" class="sel-btn btn btn-primary">Studio Berlin Pankow</button>
              <button @click="localClicked('Studio-Berlin-Reinickendorf')" class="sel-btn btn btn-primary">Studio Berlin Reinickendorf</button>
              <button @click="localClicked('Studio-Berlin-Köpenick')" class="sel-btn btn btn-primary">Studio Berlin Köpenick</button>
              <button @click="localClicked('Studio-Potsdam')" class="sel-btn btn btn-primary">Studio Potsdam</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @import 'IkPopup';
</style>
